import {LitElement, html, css} from 'lit';

class WcSpoiler extends LitElement {
    static properties = {
        isShown: {state: true},
        label: {type: String}
    };

    static styles = css`
        :host { position: relative; display: inline-block; vertical-align: bottom;}
        #label-button {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0px;
            left: 0px;
            background-color: black;
            border: none;
        }
        #label-button[aria-pressed="true"] {
            background-color: transparent;
        }
        #button-text, #live-area {
            clip: rect(0 0 0 0);
            height: 0px;
            width: 0px;
            padding: 0px;
            margin: 0px;
            overflow: hidden;
        }
    `;
    
    constructor() {
        super();
        this.isShown = false;
    }

    render() {
        const label = this.getAttribute("label") ? this.getAttribute("label") : "Toggle to read spoiler";

        return html`
            <slot aria-hidden="true"></slot>
            <div id="live-area" aria-live="polite"></div>
            <button id="label-button" aria-role="switch" @click="${this._click}"><div id="button-text">${label}</div></button>
        `;
    }

    

    _click() {
        this.isShown = !this.isShown;
        this.shadowRoot.querySelector("slot").ariaHidden = this.isShown ? "false" : "true";
        this.shadowRoot.querySelector("#label-button").ariaPressed = this.isShown ? "true" : "false";
        this.shadowRoot.querySelector("#live-area").textContent = this.isShown ? this.textContent : "";
    }
}

window.customElements.define('wc-spoiler', WcSpoiler);